import { createSlice } from 'utils/redux';

import { NAME } from './constants';
import { progressiveWebAppSlice } from './ProgressiveWebApp/slice';
import { brandReviewSlice } from './BrandReview/slice';

import type { PayloadAction } from '@reduxjs/toolkit';
import type { UserSubscription, UserSubscriptionCancellationStep } from './types';

export interface IUser {
  id: string;
  username: string;
  firstName: string;
  email: string;
  subscription: UserSubscription | null;
  cancellationStep: UserSubscriptionCancellationStep;
  preferredLanguageCode: string | null;
  onboardedAt: string | null;
  studyInNativeLanguage: boolean;
}

export const userSlice = createSlice(
  {
    name: NAME,
    initialState: {
      id: '',
      username: '',
      firstName: '',
      email: 'test@email.com',
      subscription: null,
      cancellationStep: null,
      preferredLanguageCode: null,
      onboardedAt: null,
      studyInNativeLanguage: false,
    } as IUser,
    reducers: {
      setId: (state, action: PayloadAction<IUser['id']>) => {
        state.id = action.payload;
      },
      setUsername: (state, action: PayloadAction<IUser['username']>) => {
        state.username = action.payload;
      },
      setFirstName: (state, action: PayloadAction<IUser['firstName']>) => {
        state.firstName = action.payload;
      },
      setEmail: (state, action: PayloadAction<IUser['email']>) => {
        state.email = action.payload;
      },
      setSubscription: (state, action: PayloadAction<IUser['subscription']>) => {
        state.subscription = action.payload;
      },
      setCancellationStep: (state, action: PayloadAction<IUser['cancellationStep']>) => {
        state.cancellationStep = action.payload;
      },
      setPreferredLanguageCode: (state, action: PayloadAction<IUser['preferredLanguageCode']>) => {
        state.preferredLanguageCode = action.payload;
      },
      setOnboardedAt: (state, action: PayloadAction<IUser['onboardedAt']>) => {
        state.onboardedAt = action.payload;
      },
      setStudyInNativeLanguage: (state, action: PayloadAction<IUser['studyInNativeLanguage']>) => {
        state.studyInNativeLanguage = action.payload;
      },
    },
  },
  { progressiveWebAppSlice, brandReviewSlice }
);

export const { setId, setUsername, setFirstName, setEmail, setSubscription, setCancellationStep, setPreferredLanguageCode, setOnboardedAt, setStudyInNativeLanguage, resetState } =
  userSlice.actions;
